import { AlpineComponent } from '@alpinejs/csp';

import { shift, arrow, autoPlacement, computePosition } from '@floating-ui/dom';

const Tooltip = (): AlpineComponent => ({
  open: false,
  id: undefined,
  popup: undefined,
  arrow: undefined,

  headline: undefined,
  content: undefined,

  init() {
    const element = this.$root;

    const config = JSON.parse(element.getAttribute('data-config'));
    this.headline = config.headline;
    this.content = config.content;

    this.id = element.getAttribute('aria-describedby');
    const nextElement = element.nextElementSibling;

    if (nextElement && nextElement.classList.contains('tooltip__popup')) return;
    const popup = document.createElement('div');
    popup.classList.add('tooltip__popup');
    popup.id = this.id;
    popup.role = 'tooltip';
    popup.setAttribute('aria-hidden', 'true');

    popup.innerHTML = `
      <div class="tooltip__arrow"></div>
      <h3 class="typo-headline-4">
        <svg width="24" height="24" viewbox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.044 8.84578C12.2097 8.84578 12.3631 8.82048 12.504 8.76987C12.6449 8.71505 12.7671 8.63914 12.8707 8.54214C12.9702 8.44093 13.051 8.32285 13.1132 8.18789C13.1712 8.04872 13.2002 7.89479 13.2002 7.7261C13.2002 7.55741 13.1712 7.40348 13.1132 7.26431C13.051 7.12515 12.9702 7.00706 12.8707 6.91007C12.7671 6.80885 12.6449 6.73294 12.504 6.68233C12.3631 6.62751 12.2097 6.6001 12.044 6.6001C11.8824 6.6001 11.7311 6.62751 11.5902 6.68233C11.4493 6.73294 11.3291 6.80885 11.2297 6.91007C11.1261 7.00706 11.0452 7.12515 10.9872 7.26431C10.9292 7.40348 10.9002 7.55741 10.9002 7.7261C10.9002 7.89479 10.9292 8.04872 10.9872 8.18789C11.0452 8.32285 11.1261 8.44093 11.2297 8.54214C11.3291 8.63914 11.4493 8.71505 11.5902 8.76987C11.7311 8.82048 11.8824 8.84578 12.044 8.84578ZM12.9951 17.4001V10.8085H11.1053V17.4001H12.9951Z" fill="currentColor"></path>
        </svg>
    
        <span>${this.headline}</span>
      </h3>
    
      <div class="richtext richtext--small">
      ${this.content}
      </div>
    `;

    element.after(popup);

    this.popup = popup;
    this.arrow = this.popup.querySelector('.tooltip__arrow');

    this.handlePosition();
  },
  getClassName() {
    return this.open ? 'open' : '';
  },
  handleClick() {
    this.open = !this.open;
  },
  handleOutsideClick() {
    this.open = false;
  },
  handlePosition() {
    computePosition(this.$root, this.popup, {
      middleware: [
        autoPlacement({
          allowedPlacements: ['top', 'bottom']
        }),
        shift(),
        arrow({
          element: this.arrow
        })
      ]
    }).then(({ x, y, middlewareData, placement }) => {
      this.popup.setAttribute('data-placement', placement);
      const multiplier = placement === 'bottom' ? 1 : -1;

      Object.assign(this.popup.style, {
        left: `${x}px`,
        top: `${y - 12 * multiplier}px`
      });

      if (middlewareData.arrow) {
        const { x, y } = middlewareData.arrow;

        Object.assign(this.arrow.style, {
          left: x != null ? `${x}px` : '',
          top: y != null ? `${y - 12 * multiplier}px` : ''
        });
      }
    });
  },
  handlePopupToggle() {
    this.popup.setAttribute('aria-hidden', !this.open);
  }
});

export default Tooltip;
